import InlineToolbarButton from './components/InlineToolbarButton'
import { Subject } from 'rxjs'
import AnnotationTextNode from './components/AnnotationTextNode'
import pureDecorator from '../pluginCommon/pureDecorator'
import './styles.scss'

export const ANNOTATION_STYLE = 'ANNOTATION'

export default (config = {}) => {
  const store = {
    getEditorState: undefined,
    setEditorState: undefined,
    updateInlineToolbar: undefined,
  }

  const formEditorSubject = new Subject()

  return {
    key: 'annotations-plugin',
    initialize: ({ getEditorState, setEditorState, getPlugins }) => {
      store.getEditorState = getEditorState
      store.setEditorState = setEditorState
      store.updateInlineToolbar = (visibility, content) => {
        const inlineToolbar = getPlugins().find(
          (plugin) => plugin.id === 'inline-toolbar'
        )
        if (inlineToolbar && inlineToolbar.updateToolbar) {
          inlineToolbar.updateToolbar(visibility, content)
        }
      }
    },
    onChange: (editorState) => {
      formEditorSubject.next({
        type: 'editor',
        selection: editorState.getSelection(),
      })
      return editorState
    },
    decorators: [
      {
        strategy: (contentBlock, cb, contentState) => {
          if (!contentState) return
          contentBlock.findEntityRanges((character) => {
            const entityKey = character.getEntity()
            return (
              entityKey !== null &&
              contentState.getEntity(entityKey).getType() === ANNOTATION_STYLE
            )
          }, cb)
        },
        matchesEntityType: (type) => type === ANNOTATION_STYLE,
        component: pureDecorator(AnnotationTextNode, {
          store,
          clickSubject: formEditorSubject,
        }),
      },
    ],
    AnnotationComponent: pureDecorator(InlineToolbarButton, {
      formSubject: formEditorSubject,
      store,
    }),
  }
}
